import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import PromobitRowCard from './PromobitRowCard';
import StoresRowCard from './StoresRowCard';

const OfferComparator = ({
  gaEventCategory,
  isPromobitHasTheBestPrice = false,
  offerId,
  offersToCompare,
  offerCoupon,
  offerCta,
  offerPrice,
  offerSlug,
  offerUserVisibility,
}) => (
  <section className="mb-8 flex flex-col gap-y-4 lg:mb-16">
    <Heading className="mb-2" size="size4">
      {placeholder('titles.compareToOtherOffers')}
    </Heading>
    <PromobitRowCard
      gaEventCategory={gaEventCategory}
      isPromobitHasTheBestPrice={isPromobitHasTheBestPrice}
      offerCoupon={offerCoupon}
      offerCta={offerCta}
      offerId={offerId}
      offerPrice={offerPrice}
      offerSlug={offerSlug}
      offerUserVisibility={offerUserVisibility}
    />
    {offersToCompare.map(({ id, price, redirect, store: { image, name } }) => (
      <StoresRowCard
        key={id}
        gaEventCategory={gaEventCategory}
        isPromobitHasTheBestPrice={isPromobitHasTheBestPrice}
        offerCompareId={id}
        offerId={offerId}
        offerPrice={price}
        redirectUrl={redirect}
        storeImage={image}
        storeName={name}
      />
    ))}
  </section>
);

OfferComparator.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isPromobitHasTheBestPrice: PropTypes.bool,
  offerId: PropTypes.number.isRequired,
  offersToCompare: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      redirect: PropTypes.string.isRequired,
      created: PropTypes.string.isRequired,
      store: PropTypes.shape({
        domain: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
  offerCoupon: PropTypes.string,
  offerCta: PropTypes.string,
  offerPrice: PropTypes.number.isRequired,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string,
};

export default OfferComparator;
